// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
/**
 * The tones, and what each is for. An organization's access and a subscription's status both draw
 * from this one set, so "active" cannot end up green in one list and gold in another.
 */
export type TyChipTone = "good" | "warn" | "bad" | "neutral" | "accent" | "dark";

type Props = { label: string; tone?: TyChipTone; size?: "sm" | "md" };

/**
 * A derived value, shown. **Never an editable control** — a subscription's state is the outcome of
 * dates and payments, so a chip that can be clicked to change what it reports stops being a report.
 * Changing a state happens through the action that causes it.
 */
export default function StatusChip({ label, tone = "neutral", size = "md" }: Props) {
    return <span className={`status-chip status-chip--${tone} status-chip--${size}`}>{label}</span>;
}
